import { render, staticRenderFns } from "./AreaDictionary.vue?vue&type=template&id=30625d76&scoped=true"
import script from "./AreaDictionary.vue?vue&type=script&lang=js"
export * from "./AreaDictionary.vue?vue&type=script&lang=js"
import style0 from "./AreaDictionary.vue?vue&type=style&index=0&id=30625d76&prod&lang=stylus&scoped=true"
import style1 from "./AreaDictionary.vue?vue&type=style&index=1&id=30625d76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30625d76",
  null
  
)

export default component.exports